import React from 'react';
import logo from '../../assets/RRHouseLogoCircle.svg'

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import CircularProgress from '@material-ui/core/CircularProgress'

const styles = theme => ({

    loginDiv: {
        marginTop: "40px",
        marginLeft: "35px",
        marginRight: "35px",
    },
    forogtPasswordButtonStyles: {
        position: "relative",
        bottom: "0px",

        display: "block",
        margin: "auto",
        width: "300px",
        marginTop: "20px",
        marginBottom: "50px",
        color: "black",
    },
    loginButtonStyle: {
        borderRadius: 11,
        border: 0,
        marginTop: 20,
        color: 'white',
        backgroundColor: '#66BB6A',

        '&:hover': {
            backgroundColor: '#409144',
        }
    },
    createAccountButtonStyle: {
        borderRadius: 11,
        border: 0,
        marginTop: 20,
        color: 'white',
        backgroundColor: theme.palette.action.main,

        '&:hover': {
            backgroundColor: 'rgb(40, 40, 40)',
        }
    },
    textFieldStyle: {
        marginTop: '50px',
    },
    captionTypographyStyle:{
        textAlign: 'center',
    },
    logo: {
        background: 'url(' + logo + ')',
        width: "50px",
        height: "50px",
        backgroundSize: 'cover',
        margin: "auto",
        position: "absolute",
        top: 25, 
        left: 25,
    },
    titleStyle: {
        marginLeft: 50,
        marginTop: 10,
    },
    wrapper: {
        margin: theme.spacing.unit,
        position: 'relative',
    },
    buttonProgress: {
        color: theme.palette.primary.main,
        position: 'absolute',
        top: '50%',
        left: '50%',
        marginLeft: -12,
        marginTop: -5,
    },
});


const LoginMobile = ({ classes, theme, loading, userNameTextChanged, passwordTextChanged, didPressEnter, showforgotPasswordDialog, navCreateAccount, signIn }) => {
    return (                           
        <div>
            <div className={classes.loginDiv}>
                <div className={classes.logo} />
                <Typography variant="display1" className={classes.titleStyle} >
                    Login
                </Typography>
                <form>
                    <TextField id="email" label="Email" type="username" className={classes.textFieldStyle} fullWidth margin="normal" onChange={userNameTextChanged}/>

                    <TextField id="password" label="Password" type="password" autoComplete="current-password" fullWidth margin="normal" onChange={passwordTextChanged} onKeyPress={didPressEnter}/>
                </form>
                <div className={classes.wrapper}>
                    <Button variant='raised' className={classes.loginButtonStyle} color="primary" fullWidth onClick={signIn} disabled={loading} >
                        Login
                    </Button>
                    {loading && <CircularProgress size={30} className={classes.buttonProgress} />}
                </div>
                <Button variant='raised' className={classes.createAccountButtonStyle} fullWidth onClick={navCreateAccount} >
                    Create Account
                </Button>
            </div>

            <div>
                <Button color="primary" className={classes.forogtPasswordButtonStyles} onClick={showforgotPasswordDialog} >
                    Forgot Password?
                </Button>
            </div>
            <Typography variant="caption" className={classes.captionTypographyStyle}>
                Copyright © 2019 Arch Bend Company. All rights reserved.
            </Typography>
        </div>
    );
}

export default withStyles(styles, { withTheme: true })(LoginMobile);



// WEBPACK FOOTER //
// ./src/components/Login/LoginMobile.js